module.exports = __webpack_public_path__ + "img/TechArmorWallS_ua.839b5d5d.webp";